export const boardAddFormTour = {
  key: "boardAddForm",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-addform-basics"]',
      content: t("Tour_BoardAddForm_Basics"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-addform-fields"]',
      content: t("Tour_BoardAddForm_Fields"),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-addform-submit"]',
      content: t("Tour_BoardAddForm_Submit"),
      placement: "bottom",
    },
  ],
};
